import React from 'react';
import { Row, Col, Form } from 'react-bootstrap'
import Date from '../../date/conversational'
import HourLabel from '../../hours/label'
import DurationLabel from '../../durations/label'
import LocationLabel from '../../locations/label'
import FacilitatorLabel from '../../facilitators/label'
import ActionMenu from '../action-menu'
import DimensionPills from './dimension-pills'
import './experience-record.scss'
import { Clipboard, PeopleFill, ClipboardCheck, Incognito } from 'react-bootstrap-icons'
import CountLabel from './enrollment-count-label';
import { useExperienceScreen } from './use-experience-screen';

export default ({ experience }) => {
    const {isCourseSelected, toggleSelectedCourse} = useExperienceScreen();
    const {
        isSecretEnrollment: isSecret,
        private: isPrivate
    } = experience;
    const EnrollmentIcon = isPrivate ? Clipboard : ClipboardCheck;
    const AttendanceIcon = isSecret ? Incognito : PeopleFill;
    return (
        <div className='experience-record'>
            <div>
                <Form.Check
                    type="checkbox"
                    size='sm'
                    checked={isCourseSelected(experience)}
                    onChange={() => toggleSelectedCourse(experience)}
                />
            </div>
            <div className='content'>
                <Row noGutters>
                    <Col xs={12} md={9}>
                        <Row>
                            <Col xs={12} className='date'><Date date={experience.date} full={true} /> | <HourLabel hourId={experience.hourId} /> | <DurationLabel durationId={experience.durationId} /></Col>
                            <Col xs={12} className='ellipsis-overflow'><strong>{experience.name}</strong></Col>
                            <Col xs={12} className='facilitator'><LocationLabel locationId={experience.locationId} /> with <FacilitatorLabel formal facilitatorId={experience.facilitatorId} /></Col>
                        </Row>    
                    </Col>
                    <Col xs={12} md={3}>
                        <Row>
                            <Col xs={12} className='grouped'><DimensionPills dimensions={experience.dimensions} /></Col>
                            <Col xs={12} className={`grouped ${isPrivate ? 'text-muted' : ''}`}>
                                <CountLabel experience={experience} />
                                <EnrollmentIcon
                                    size={20}
                                    color={ !isPrivate ? 'green' : undefined }
                                    title={isPrivate ? ' Private' : 'Public'}
                                />
                            </Col>
                            <Col xs={12} className='grouped'>
                                {experience.totalAttendeeCount}
                                <AttendanceIcon
                                    size={20}
                                    title={isSecret ? ' Secret' : 'Public'}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div>
                <ActionMenu experience={experience} />
            </div>
        </div>
    );
};